import {Component, inject, OnInit, Renderer2, signal, ViewChild} from '@angular/core';
import {TableComponent, TableOptions} from "@shared/components";
import {APIService} from '@core/services';
import {PatientService} from '@core/services/patient.service';
import {Allergy} from '@core/classes/tables/allergy';
import {HttpHeaders} from '@angular/common/http';
import {PhysicalFinding} from '@core/classes/tables/physical-finding';
import {Medication} from '@core/classes/tables/medication';
import {NavigationEnd, Router} from '@angular/router';
import {
  SurgicalProcedureStatusActionComponent
} from '@modules/cy/patient/ps/components/surgical-procedures/actions/surgical-procedure-status-action/surgical-procedure-status-action.component';
import {
  AddSurgicalProcedureComponent
} from '@modules/cy/patient/ps/components/surgical-procedures/actions/add-surgical-procedure/add-surgical-procedure.component';
import {
  PhysicalFindingStatusActionComponent
} from '@modules/cy/patient/ps/components/physical-findings/actions/physical-finding-status-action/physical-finding-status-action.component';
import {
  AddPhysicalFindingComponent
} from '@modules/cy/patient/ps/components/physical-findings/actions/add-physical-finding/add-physical-finding.component';
import {Subject, takeUntil} from 'rxjs';

@Component({
  selector: 'ncp-physical-findings',
    imports: [
        TableComponent
    ],
  templateUrl: './physical-findings.component.html',
  styleUrl: './physical-findings.component.scss',
})
export class PhysicalFindingsComponent implements OnInit {
  @ViewChild('physicalFindings') public physicalFindingsEl!: TableComponent<PhysicalFinding>;
  protected readonly router = inject(Router);
  protected apiService = inject(APIService);
  protected patientService = inject(PatientService);
  protected renderer2 = inject(Renderer2);

  private subscription: any;
  private destroy$ = new Subject<void>();

  protected options = signal<TableOptions<PhysicalFinding>>(
    new TableOptions<PhysicalFinding>({
      id: 'physicalFindings',
      type: 'PhysicalFindings',
      interface: PhysicalFinding,
      autoLoadData: false,
      ignoreColumns: (this.router.url === '/cy/patient/ps/create' || this.router.url === '/cy/patient/ps/edit')? [] : ['status'],
      pagination: {
        itemsPerPage: 10,
        pageNumber: 1,
        totalItems: 0,
      },
      searchComponent: null,
    })
  );

  ngOnInit(): void {
    this.getData(
      (this.router.url === '/cy/patient/ps/edit' || this.router.url === '/cy/patient/ps/create') ? -1 : 0,
      (this.router.url === '/cy/patient/ps/edit' || this.router.url === '/cy/patient/ps/create') ? -1 : 0
    );

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (this.subscription) {
          this.subscription.unsubscribe();
        }
      }
    });
  }

  protected getData = (mode: number = 0, status: number = 0) => {
    this.subscription = this.apiService
      .call({
        path: '/get-blood-presure',
        headers: new HttpHeaders().set('pToken', this.patientService.pToken || ''),
        body: {
          mode: mode,
          status: status,
          version_id: this.patientService.patient?.version?.id || -1
        }
      })?.pipe(takeUntil(this.destroy$)).subscribe((response: any) => {
      if(response && response.status === 1) {
        this.options.set(
          new TableOptions<PhysicalFinding>({
            id: 'physicalFindings',
            type: 'PhysicalFindings',
            interface: PhysicalFinding,
            data: response.data,
            autoLoadData: false,
            ignoreColumns: (this.router.url === '/cy/patient/ps/create' || this.router.url === '/cy/patient/ps/edit') ? [] : ['status'],
            actionsComponent: (this.router.url === '/cy/patient/ps/create' || this.router.url === '/cy/patient/ps/edit') ? PhysicalFindingStatusActionComponent : undefined,
            extraComponent: (this.router.url === '/cy/patient/ps/create' || this.router.url === '/cy/patient/ps/edit') ? AddPhysicalFindingComponent : undefined,
            pagination: {
              itemsPerPage: 10,
              pageNumber: 1,
              totalItems: response.data.length,
            },
            renderCustomRow: (td: HTMLTableCellElement, row: {}, item: string) => {
              const data = row as PhysicalFinding;
              if (item === 'blood_pressure') {
                td.innerHTML = data.systolic + ' / ' + data.diastolic + ' mmHg';
              }
              if (item === 'status') {
                td.innerHTML = '';

                let iEl = this.renderer2.createElement('h2');
                if(data.status === 1) {
                  this.renderer2.addClass(iEl, 'bi');
                  this.renderer2.addClass(iEl, 'bi-eye');
                  this.renderer2.addClass(iEl, 'text-primary');
                } else {
                  this.renderer2.addClass(iEl, 'bi');
                  this.renderer2.addClass(iEl, 'bi-eye-slash');
                  this.renderer2.addClass(iEl, 'text-secondary');
                }
                this.renderer2.appendChild(td, iEl);
              }
            },
            searchComponent: null,
          })
        );
      }
    })
  }
}
